import PanelSet from "@molecules/panelset/panelset.mjs";
import * as storelocator from '@molecules/store-locator/store-locator.mjs';

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-mutualfinder');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const mainRow = container.querySelector('.js-mutualfinder-mainrow .horizontal-list-content');
  const highlightSection = container.querySelector('.js-mutualfinder-highlight');
  const highlightedRow = container.querySelector('.js-mutualfinder-highlightedrow');

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.mutualFinder = {
    // Constants
    PANEL_FORM_POSTAL     : 'FORM_POSTAL',
    PANEL_FORM_DETAILS    : 'FORM_DETAILS',
    PANEL_SEARCHED_POSTAL : 'SEARCH_POSTAL',
    PANEL_SEARCHED_DETAILS: 'SEARCH_DETAILS',

    // Properties
    panels: new PanelSet(),

    // Methods

    getMutualCard: function(mutualId) {
      return container.querySelector(`[data-mutual-id='${mutualId}']`)?.parentElement;
    },
    highlightCard: function(card) {
      if (!card) return;

      // Show highlight section.
      highlightSection.classList.remove('d-none');

      // Remove mobile 'show' button.
      container.querySelector('.js-mutualfinder-mobile-toggler').classList.add('d-none');

      // Move form card to the highlighted row.
      this.moveCardToRow(this.getMutualCard('FORM'), highlightedRow);

      // Move the previously highlighted card to the front of the main row.
      if (highlightedRow.children.length >= 2) this.moveCardToRow(highlightedRow.children[1], mainRow);

      // Move the highlighted card to the end of the search row.
      this.moveCardToRow(card, highlightedRow, -1);
    },
    moveCardToRow: function (card, row = mainRow, position = 0) {
      if (!card || !row) return;
      if (position < 0) position = Infinity;
      if (position <= row.children.length-1) {
        row.insertBefore(card, row.children[position]);
      }
      else {
        row.insertAdjacentElement('beforeend', card);
      }
    },
    hideNotFound: function () {
      this.getMutualCard('NOTFOUND').setAttribute('hidden', true);
    },
    displayNotFound: function() {
      this.highlightCard(this.getMutualCard('NOTFOUND'));
      this.getMutualCard('NOTFOUND').removeAttribute('hidden');
    }
  };

  const PMF = Promutuel.mutualFinder;
  PMF.panels
    .withPanel(
      PMF.PANEL_FORM_POSTAL,
      container.querySelector('.js-slocpanel-postalcode'),
    )
    .withPanel(
      PMF.PANEL_FORM_DETAILS,
      container.querySelector('.js-slocpanel-personalinfo'),
      {
        show: function(panel) {
          const card = panel.parentElement.parentElement;
          card.classList.add('horizontal-list-card--double');
          return true;
        },
        hide: function (panel) {
          const card = panel.parentElement.parentElement;
          card.classList.remove('horizontal-list-card--double');
          return true;
        },
      },
    )
    .withPanel(
      PMF.PANEL_SEARCHED_POSTAL,
      container.querySelector('.js-mutualfinder-searched-pc'),
    )
    .withPanel(
      PMF.PANEL_SEARCHED_DETAILS,
      container.querySelector('.js-mutualfinder-searched-pi'),
    )
    .goTo(PMF.PANEL_FORM_POSTAL);

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_mutualFinder = {
    attach: function attach(context) {

      $(once('promutuelMutualFinder', '.js-mutualfinder', context)).each(function () {
        const breakpointLG = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg');

        // ---------------------------------------------------------------------
        // Default layout.

        // Hide the 'not found' card by default.
        PMF.hideNotFound();
        // If a mutual is currently selected,move its card just after the form).
        PMF.moveCardToRow(PMF.getMutualCard(Promutuel.mutuals?.getMyMutualId()), mainRow, 1);

        // ---------------------------------------------------------------------
        // Navigation between finder forms

        container.querySelector('.js-slocpanel-postalcode-toggle').addEventListener('click', event => {
          event.preventDefault();
          PMF.panels.goTo(PMF.PANEL_FORM_POSTAL);
        });
        container.querySelector('.js-slocpanel-personalinfo-toggle').addEventListener('click', event => {
          event.preventDefault();
          PMF.panels.goTo(PMF.PANEL_FORM_DETAILS);
        });
        container.querySelectorAll('.js-mutualfinder-back').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            PMF.panels.goBack();
          });
        });

        // ---------------------------------------------------------------------
        // Mobile form

        // On mobile only: immediately move the form card to the highlightedrow.
        if (!window.matchMedia(`(min-width:${breakpointLG})`).matches) {
          PMF.moveCardToRow(PMF.getMutualCard('FORM'), highlightedRow);

          container.querySelectorAll('.js-mutualfinder-showform').forEach(node => {
              node.addEventListener('click', event => {
              event.preventDefault();
              // Show highlight section.
              highlightSection.classList.remove('d-none');
              // Show forms
              container.querySelectorAll('.js-mutualfinder-form').forEach(node => {
                node.classList.add('mutual-finder__formpanel--open');
              });

              Promutuel.header?.show();
              // Freeze body to prevent scrolling.
              document.body.classList.add('overflow-hidden');
            });
          });

          container.querySelectorAll('.js-slocpanel-hide').forEach(node => {
            node.addEventListener('click', event => {
              event.preventDefault();
              // Hide highlight section if no card is highlighted.
              if (highlightedRow.children.length <= 1) {
                highlightSection.classList.add('d-none');
              }
              // Hide forms
              container.querySelectorAll('.js-mutualfinder-form').forEach(node => {
                node.classList.remove('mutual-finder__formpanel--open');
              });
              // Display the previous result (if any).
              PMF.panels.goForward();

              // Unfreeze body.
              document.body.classList.remove('overflow-hidden');
            });
          });
        }

        // -----------------------------------------------------------------------
        // Form handlers

        // TODO Remove randomizer
        const randomMutual = async function() {
          const ids = [...Promutuel.mutuals._store.keys()];
          const id = ids[(Math.random() * ids.length) >> 0]
          return Promutuel.mutuals.getMutualDetails(id);
        }
        // Promutuel.mutuals.lookupByLocation = randomMutual;
        // Promutuel.mutuals.lookupByPostalCode = randomMutual;


        function openResultPanel(searchmode) {
          switch (searchmode) {
            case storelocator.SEARCHMODE.CLIENTINFO: {
              const formPanel = PMF.panels.getPanel(PMF.PANEL_FORM_DETAILS);
              const resultPanel = PMF.panels.getPanel(PMF.PANEL_SEARCHED_DETAILS);

              const inputFirst = formPanel.querySelector('input[id$=firstname]');
              const inputLast = formPanel.querySelector('input[id$=lastname]');
              resultPanel.querySelector('[data-field=pisearch]').textContent =
                `${inputFirst.value} ${inputLast.value}`;
              PMF.panels.goTo(resultPanel);
            } break;
            case storelocator.SEARCHMODE.GEO:
            case storelocator.SEARCHMODE.POSTAL: {
              const formPanel = PMF.panels.getPanel(PMF.PANEL_FORM_POSTAL);
              const resultPanel = PMF.panels.getPanel(PMF.PANEL_SEARCHED_POSTAL);

              const searchInput = formPanel.querySelector('input[name=postalcode]');
              resultPanel.querySelector('[data-field=pcsearch]').textContent =
                searchInput.value || searchInput.placeholder;
              PMF.panels.goTo(resultPanel);
            } break;
          }
        }

        const onMutualFound = function (data, searchmode) {
          openResultPanel(searchmode);
          PMF.hideNotFound();
          PMF.highlightCard(PMF.getMutualCard(data.mutual));
          document.body.classList.remove('overflow-hidden'); // Unfreeze body on mobile.
        };

        const onMutualNotFound = function (err, searchmode) {
          console.log(err);
          openResultPanel(searchmode);
          PMF.displayNotFound();
          document.body.classList.remove('overflow-hidden'); // Unfreeze body on mobile.
        };

        storelocator.initPostalCodeForm(container, {
          onsuccess: onMutualFound,
          onfailure: onMutualNotFound,
        });

        storelocator.initPersonalInfoForm(container, {
          idPrefix: 'mutualfinder',
          addressCompleteKey: drupalSettings.addresscomplete_key,
          onsuccess: onMutualFound,
          onfailure: onMutualNotFound,
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once);
